import React, { useMemo } from 'react';

const withLazyImages = (
  html,
  {
    lazyImages = true,
    skipFirstImageFromLazy = false,
    stripImages = false,
    stripLinks = false,
  } = {},
) => {
  if (!html || typeof html !== 'string' || typeof DOMParser === 'undefined') {
    return html;
  }

  const documentFragment = new DOMParser().parseFromString(html, 'text/html');

  if (stripImages) {
    documentFragment.querySelectorAll('img').forEach((image) => image.remove());
  }

  if (stripLinks) {
    documentFragment.querySelectorAll('a').forEach((link) => {
      link.replaceWith(...Array.from(link.childNodes));
    });
  }

  if (!lazyImages) {
    return documentFragment.body.innerHTML;
  }

  documentFragment.querySelectorAll('img').forEach((image, index) => {
    const keepEagerLoading =
      (skipFirstImageFromLazy && index === 0) ||
      image.hasAttribute('data-no-lazy') ||
      image.getAttribute('loading') === 'eager' ||
      image.getAttribute('fetchpriority') === 'high';

    if (!keepEagerLoading && !image.hasAttribute('loading')) {
      image.setAttribute('loading', 'lazy');
    }

    if (!image.hasAttribute('decoding')) {
      image.setAttribute('decoding', 'async');
    }
  });

  return documentFragment.body.innerHTML;
};

export default function RawHtml({
  children,
  className = '',
  classes = '',
  lazyImages = true,
  skipFirstImageFromLazy = false,
  stripImages = false,
  stripLinks = false,
  ...rest
}) {
  const content = useMemo(
    () =>
      withLazyImages(children, {
        lazyImages,
        skipFirstImageFromLazy,
        stripImages,
        stripLinks,
      }),
    [children, lazyImages, skipFirstImageFromLazy, stripImages, stripLinks],
  );

  return (
    <div
      {...rest}
      dangerouslySetInnerHTML={{ __html: content }}
      className={`tinymce-tables ${classes} ${className}`.trim()}
    />
  );
}
